module.exports = __webpack_public_path__ + "img/clock.c4120948.svg";